import * as fromModuleSettings from './module-settings.reducer';

import { createFeatureSelector } from '@ngrx/store';

export const selectModuleSettingsState = createFeatureSelector<fromModuleSettings.IUserControlledSettingsState>(
  fromModuleSettings.qnrModuleSettingsFeatureKey
);
